import React, { FC } from 'react';
import HeroCarouselDesktop from './components/heroCarouselDesktop';
import { CheckboxField, PropsFromGenericPopup } from '../../types/types';
import { HeroCarouselFields, HeroCarouselProps, TextColorField, TextColorSitecoreField } from './types/herobanner.types';
import { ComponentRendering, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const colorMapper: (sitecoreColor: TextColorSitecoreField) => TextColorField = (sitecoreColor) => sitecoreColor?.fields?.Key;

const fieldMapper: (sitecoreFields: HeroCarouselFields) => { items: any[]; showCarouselOverlay: CheckboxField } = (sitecoreFields) => {
  const sitecoreItems = sitecoreFields?.items;
  const showCarouselOverlay = sitecoreFields?.showCarouselOverlay;
  const items = sitecoreItems?.map(({ fields, id }) => {
    return {
      id: id,
      image: fields?.image,
      mobileImage: fields?.mobileImage,
      title: fields?.title,
      content: fields?.content,
      link: fields?.link,
      textColor: fields?.textColor ? colorMapper(fields.textColor) : '',
      video: fields?.video,
      useVideo: fields?.useVideo,
    };
  });

  return {
    items: items ?? [],
    showCarouselOverlay,
  };
};

// HeroBanner will recieve PropsFromGenericPopup if this component is inside GenericPopUp
const HeroBanner: FC<HeroCarouselProps & PropsFromGenericPopup> = (props) => {
  let fields: HeroCarouselFields;

  if (!props?.fields || !Object.keys(props?.fields).length) {
    return null;
  } else {
    fields = props?.fields;
  }

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  const mappedFields = fieldMapper(fields);
  const { items, showCarouselOverlay } = mappedFields;
  const params: any = props?.params;

  return (
    <AnalyticsVisibleEvent
      rendering={props?.rendering as ComponentRendering}
      title={props.fields?.items?.[0]?.fields?.title?.value}
      template="Hero Banner Carousel"
    >
      <HeroCarouselDesktop items={items} showCarouselOverlay={showCarouselOverlay} headingTag={params?.headingTag || 'h2'} />
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(HeroBanner);
